import { colors } from "@cerebruminc/cerebellum";
import { useAtomValue } from "jotai";
import { env } from "src/environment";
import { highContrastThemeAtom } from "src/shame/shame-atoms";
import { styled } from "styled-components";

const OuterLinkWrappingDiv = styled.div<{ $highContrast?: boolean }>`
	align-items: center;
	color: ${({ $highContrast }) => ($highContrast ? colors.BLACK : colors.COOL_GREY_85)};
	display: flex;
	font-size: 15px;
	justify-content: center;
	padding-top: 40px;
`;

const InnerLinkAElement = styled.a<{ $highContrast?: boolean }>`
	color: ${({ $highContrast }) => ($highContrast ? colors.BLACK : colors.BLUE_70)};
	opacity: 0.8;
	text-decoration-line: underline;
	&:hover {
		opacity: 1;
	}
`;

const InnerLinkSeparator = styled.div<{ $highContrast?: boolean }>`
	align-items: center;
	color: ${({ $highContrast }) => ($highContrast ? colors.BLACK : colors.BLUE_50)};
	display: flex;
	font-weight: 400;
	justify-content: center;
	width: 32px;
`;

export function AuthBoxFooter() {
	const isHighContrast = useAtomValue(highContrastThemeAtom);

	return (
		<OuterLinkWrappingDiv $highContrast={isHighContrast} id="footer">
			<InnerLinkAElement
				$highContrast={isHighContrast}
				href={env.PRIVACY_POLICY_URL}
				target="_blank"
				rel="noreferrer noopener"
				data-sentry-unmask
			>
				Privacy Policy
			</InnerLinkAElement>
			<InnerLinkSeparator $highContrast={isHighContrast} data-sentry-unmask>
				|
			</InnerLinkSeparator>
			<InnerLinkAElement
				$highContrast={isHighContrast}
				href={env.TERMS_AND_CONDITIONS_URL}
				target="_blank"
				rel="noreferrer noopener"
				data-sentry-unmask
			>
				Terms & Conditions
			</InnerLinkAElement>
		</OuterLinkWrappingDiv>
	);
}
